import { gql } from "@apollo/client";

import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const shortCaseElementFragment = gql`
  fragment ShortCaseElementFragment on Element {
    id
    configurableType {
      code
      name
    }
    properties {
      ...PropertyValueFragment
    }
  }

  ${propertyValueFragment}
`;
